<template>
    <el-drawer title="待配订单(无货)" @close="closeDialog"  direction="ltr" size="50%"  :visible="ZPWHflag">
      <div class="box">
        <div>
          货物信息》合计:
           <span v-if="goodform.allWeightT"><span class="red">{{goodform.allWeightT}}</span>吨</span>
          <span v-if="goodform.allWeightT&&(goodform.allNumber||goodform.allVolumn)">/</span>
          <span v-if="goodform.allNumber"><span class="red">{{goodform.allNumber}}</span>件</span>
          <span v-if="goodform.allNumber&&goodform.allVolumn">/</span>
          <span v-if="goodform.allVolumn"><span class="red">{{goodform.allVolumn}}</span>方</span>
        </div>
        <hr>
        <div v-for="(item,index) in rowDataList" :key="item.id"  style="padding:10px">
          <div  style="display: flex;align-items: center;">
            <div>1</div>
            <div style="display: flex;margin:0 12px;width:96%;font-size:12px">
              <div class="box1">
                <p>订单号：{{item.orderNo}}</p>
                <p>始发流向：{{item.startDirection}}</p>
              </div>
              <div class="box1">
              <p>结算客户：{{item.payee}}</p>
              <p>目的流向：{{item.endDirection}}</p>
              </div>
              <!-- <div class="box1" style="width:17%">
                <p>剩余量：<span class="red">{{item.residualWeight}}{{item.measuringUnit}}</span></p>
              </div> -->
              <div style="margin-top:12px; position: relative;">
                <div class="dingwei" v-if="index==0"><span class="red" v-if="item.measuringUnit=='吨'">*</span>重量(吨)</div>
                <el-input  placeholder="" v-number-input.float="3" maxlength="8"  v-model="item.weight"
              class="width2" @change="weightFn($event,index,'吨')"></el-input>
              </div>
              <div style="position: relative;margin:12px 10px 0">
                <div class="dingwei" v-if="index==0"><span class="red" v-if="item.measuringUnit=='件'">*</span>数量(件)</div>
                <el-input  placeholder="" v-number-input.float="0" maxlength="8"  v-model="item.number"
              class="width2" @change="weightFn($event,index,'件')"></el-input>
              </div>
              <div style="margin-top:12px; position: relative;">
                <div class="dingwei" v-if="index==0"><span class="red" v-if="item.measuringUnit=='方'">*</span>体积(方)</div>
                <el-input  placeholder="" v-number-input.float="3" maxlength="8"  v-model="item.goodVolumn"
              class="width2" @change="weightFn($event,index,'方')"></el-input>
              </div>
            </div>
            <div @click="delFn(index)"><i class="el-icon-delete"></i></div>
          </div>
          <div>
            <!-- <el-form-item label="重量(吨):"  >
              <el-input  placeholder="" v-number-input.float="3" maxlength="8"  v-model="item.weight"
              class="width2" @input="weightFn($event,index)"></el-input>
            </el-form-item>
            <el-form-item label="数量(件):"  >
              <el-input  placeholder="" v-number-input.float="3" maxlength="8"  v-model="item.weight"
              class="width2" @input="weightFn($event,index)"></el-input>
            </el-form-item>
            <el-form-item label="体积(方):"  >
              <el-input  placeholder="" v-number-input.float="3" maxlength="8"  v-model="item.weight"
              class="width2" @input="weightFn($event,index)"></el-input>
            </el-form-item> -->
          </div>
          <hr>
        </div>
      </div>

      <el-drawer title="创建运单" size="98%" @close="closeDialog"   class="rightDrawer"
       :modal="false"  :visible="ZPWHflag">
       <el-form :inline="true" ref="goodform" enctype="multipart/form-data" :model="goodform" :rules="rules"  class="demo-form-inline jiaoyan" label-width="90px" size="mini">
        <div  style="padding:12px">
            <!-- 车辆信息组件 -->
            <peiche :goodform="goodform"></peiche>
        </div>
        </el-form>
        <div class="footerBox">
          <el-button  @click="closeDialog">取消</el-button>
          <el-button type="primary" @click="saveFn(1)">提交</el-button>
          <el-button type="primary" @click="saveFn(2)">提交并继续</el-button>
        </div>
      </el-drawer>
  </el-drawer>

</template>

<script>
import peiche from '@/views/newTMS/publicFiles/wayAndOrder/peiche.vue'
import { noCargoStowage, findStowageOrderList } from '@/api/newTMS'
export default {
  name: 'zhipaiyouhuo',
  components: {
    peiche
  },
  props: {
    ZPWHflag: {
      type: Boolean,
      default: false
    },
    dataList: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      rowDataList: this.dataList,
      danwei: this.dataList[0].measuringUnit,
      goodform: { allWeight: 0 },
      rules: {
        // publishPricingMethod: [
        //   { required: true, message: '请选择计价方式', trigger: 'blur' }
        // ],
        // pricingMethod: [
        //   { required: true, message: '请选择计价方式', trigger: 'blur' }
        // ],
        payer: [
          { required: true, message: '请输入车队长名称', trigger: 'blur' }
        ],
        payerTaxId: [
          { required: true, message: '请输入身份证号', trigger: 'blur' }
        ],
        causeCancellation: [
          { required: true, message: '请输入作废原因', trigger: 'blur' }
        ],
        expenditurePattern: [
          { required: true, message: '请选择支出方式', trigger: 'blur' }
        ],
        freightPricingType: [
          { required: true, message: '请选择运费计价', trigger: 'blur' }
        ],
        freightUnitPrice: [
          { required: true, message: '请输入运费单价', trigger: 'blur' }
        ],
        allFreightAmount: [
          { required: true, message: '请输入运费金额', trigger: 'blur' }
        ],
        serviceRate: [
          { required: true, message: '请输入服务费率', trigger: 'blur' }
        ],
        serviceCharge: [
          { required: true, message: '请输入服务费', trigger: 'blur' }
        ],
        freightTaxRate: [
          { required: true, message: '请输入运费税率', trigger: 'blur' }
        ]
      }
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    this.$set(this.goodform, 'measuringUnit', this.rowDataList[0].measuringUnit)
    this.rowDataList.forEach(item => {
      this.$set(item, 'weight', item.residualWeight)
      this.$set(item, 'number', item.residualNumber)
      this.$set(item, 'goodVolumn', item.residualVolumn)
    })
    this.getall()
  },
  methods: {
    // 输入配载量
    weightFn (e, index, danwei) {
      if (danwei == '吨') {
        if (e > this.rowDataList[index].residualWeight) {
          this.$alert('配载量不能大于剩余量', '系统提示')
          this.$set(this.rowDataList[index], 'weight', '')
        }
      }
      if (danwei == '件') {
        if (e > this.rowDataList[index].residualNumber) {
          this.$alert('配载量不能大于剩余量', '系统提示')
          this.$set(this.rowDataList[index], 'number', '')
        }
      }
      if (danwei == '方') {
        if (e > this.rowDataList[index].residualVolumn) {
          this.$alert('配载量不能大于剩余量', '系统提示')
          this.$set(this.rowDataList[index], 'goodVolumn', '')
        }
      }
      if (e != '' && Number(e) === 0) {
        this.$alert('输入的值不能为0', '系统提示')
        if (danwei == '吨') {
          this.$set(this.rowDataList[index], 'weight', '')
        } else if (danwei == '件') {
          this.$set(this.rowDataList[index], 'number', '')
        } else if (danwei == '方') {
          this.$set(this.rowDataList[index], 'goodVolumn', '')
        }
      }
      this.getall()
    },
    getall () {
      let rowDataWeight = 0
      let rowDataNumber = 0
      let rowDataVolumn = 0
      this.rowDataList.forEach(item => {
        if (item.weight) {
          rowDataWeight = (rowDataWeight * 1000 + item.weight * 1000) / 1000
        }
        if (item.number) {
          rowDataNumber = (rowDataNumber * 1000 + item.number * 1000) / 1000
        }
        if (item.goodVolumn) {
          rowDataVolumn = (rowDataVolumn * 1000 + item.goodVolumn * 1000) / 1000
        }
      })
      this.$set(this.goodform, 'allWeightT', rowDataWeight)
      this.$set(this.goodform, 'allNumber', rowDataNumber)
      this.$set(this.goodform, 'allVolumn', rowDataVolumn)
      if (this.danwei == '吨') {
        this.$set(this.goodform, 'allWeight', rowDataWeight)
      } else if (this.danwei == '件') {
        this.$set(this.goodform, 'allWeight', rowDataNumber)
      } else if (this.danwei == '方') {
        this.$set(this.goodform, 'allWeight', rowDataVolumn)
      }
    },
    // 保存
    saveFn (n) {
      let flag = this.rowDataList.some(item => !item.weight)
      let flag1 = this.rowDataList.some(item => !item.number)
      let flag2 = this.rowDataList.some(item => !item.goodVolumn)
      if (this.danwei == '吨' && flag) {
        this.$alert('重量不能为空', '系统提示')
        return
      }
      if (this.danwei == '件' && flag1) {
        this.$alert('数量不能为空', '系统提示')
        return
      }
      if (this.danwei == '方' && flag2) {
        this.$alert('体积不能为空', '系统提示')
        return
      }
      if (!this.goodform.generalTaxId && !this.goodform.driverId) {
        this.$alert('请选择司机', '系统提示')
        return false
      }
      if (!this.goodform.generalTaxId && !this.goodform.plateNumber) {
        this.$alert('请选择车辆', '系统提示')
        return false
      }
      this.$refs.goodform.validate((valid) => {
        if (valid) {
          let arr = []
          let orderid = []
          this.rowDataList.forEach((item) => {
            orderid.push(item.orderId)
            let callVolume = 0
            if (item.measuringUnit == '吨') {
              callVolume = item.weight
            } else if (item.measuringUnit == '件') {
              callVolume = item.number
            } else if (item.measuringUnit == '方') {
              callVolume = item.goodVolumn
            }
            console.log(callVolume)
            arr.push({
              orderBusinessId: item.orderBusinessId,
              callVolume: callVolume,
              weight: item.weight,
              number: item.number,
              volumn: item.goodVolumn
            })
          })
          this.goodform.stowageOrderList = arr
          if (this.goodform.collectionType == 2) { // 司机
            this.$set(this.goodform, 'payer', this.goodform.driverName)
            this.$set(this.goodform, 'payerTaxId', this.goodform.idNumber)
          }
          // 后台是用payee接收的 再重新赋值一下
          this.$set(this.goodform, 'payee', this.goodform.payer)
          this.$set(this.goodform, 'payeeTaxId', this.goodform.payerTaxId)
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          noCargoStowage(this.goodform).then(res => {
            loading.close()
            this.$parent.searchFn()
            if (n == 1) {
              this.$emit('update:ZPWHflag', false)
            } else {
              let rowDataList = []
              findStowageOrderList({ orderIds: orderid }).then(res => {
                console.log(res)
                this.rowDataList.forEach(item => {
                  let json = res.filter(item1 => item1.orderId == item.orderId)
                  item.weight = json[0].residualWeight
                  item.number = json[0].residualNumber
                  item.goodVolumn = json[0].residualVolumn
                  if ((this.danwei == '吨' && json[0].residualWeight !== 0) || (this.danwei == '件' && json[0].residualNumber !== 0) ||
                  (this.danwei == '方' && json[0].residualVolumn !== 0)) {
                    rowDataList.push(item)
                  }
                })
                this.rowDataList = rowDataList
                this.getall()
              })

              this.$forceUpdate()
              this.$set(this.goodform, 'plateNumber', '')
              this.$set(this.goodform, 'licensePlateColor', '')
              this.$set(this.goodform, 'licensePlateColorName', '')
              this.$set(this.goodform, 'vehicleType', '')
              this.$set(this.goodform, 'vehicleTypeName', '')
              this.$set(this.goodform, 'energyType', '')
              this.$set(this.goodform, 'energyTypeName', '')
              this.$set(this.goodform, 'driverId', '')
              this.$set(this.goodform, 'driverName', '')
              this.$set(this.goodform, 'driverPhone', '')
              this.$set(this.goodform, 'idNumber', '')
            }
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    delFn (index) {
      if (this.rowDataList.length == 1) {
        this.$alert('已经是最后一条订单了，不能再删除了', '系统提示')
        return
      }
      this.rowDataList.splice(index, 1)
      this.getall()
    },
    closeDialog () {
      this.$emit('update:ZPWHflag', false)
    }
  },
  destroyed () {

  }
}
</script>

<style scoped lang='less'>
.box{
  padding:20px;
  .dingwei{
    position: absolute;
    right: 0px;
    top: -27px;
    width: 75px;
  }
}
.box1{
  width: 30%;
  display: flex;
  flex-wrap:wrap;
  flex-direction: column;
  p{
    margin-right: 10px;
    margin-top: 0;
  }
}
.gjh {
    height: 70px;
    width: 300px;
    /deep/.el-textarea__inner{
      height: 100%;
    }
}
/deep/.el-form-item--mini.table_error {
  margin-bottom: 0 !important;
  margin: 6px 0 !important;
}
.width2  /deep/.el-input__inner{
    width: 100px;
}
</style>
